import React, { useState } from 'react'
import { cDocuments, icosIndicators } from '../../../../app/Paths'
import { FiEdit, FiEye, FiPrinter, FiRefreshCcw, FiTrash2 } from 'react-icons/fi';
import { Table } from '../../../../components/Tables/Table';
import Swal from 'sweetalert2';
import { M_NewBillings } from './M_NewBillings';
import { useDispatch, useSelector } from 'react-redux';
import { billings_status, billings_status_colors, memberships_status, memberships_status_colors, orders_status, orders_status_colors } from '../../../../app/Constants';
import { activateBillings, deactivateBillings } from '../../../store/Thunk';

export const Billings = () => {

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (type) => {
    // setSearchType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // setSearchType(null);
  };


  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(null);
  const { idCustomer, billings } = useSelector(state => state.customerDetail);

  const data = [...billings];

  let columns = [
    {
      header: 'RFC',
      dataIndex: 'RFC',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'RAZON SOCIAL',
      dataIndex: 'RAZON_SOCIAL',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'CORREO',
      dataIndex: 'CORREO',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: true, // 👈 sumará esta columna
    },
    {
      header: 'TELEFONO',
      dataIndex: 'TELEFONO',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: true, // 👈 sumará esta columna
    },
    {
      header: 'FECHA REGISTRO',
      dataIndex: 'FECHA',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'ESTADO',
      dataIndex: 'ESTADO',
      classHeader: 'text-center',
      classRow: 'text-center',
      isAction: true,
      isTotal: false, // 👈 sumará esta columna
      renderer: (value) => {
        const code = Number(value);
        return (
          <span className={`badge text-white ${billings_status_colors[code]}`}>
            {billings_status[code]}
          </span>
        );
      }
    },
    {
      header: 'ACCIONES',
      dataIndex: 'ESTADO',
      classHeader: 'text-center',
      classRow: 'text-center',
      isAction: true,
      renderer: (value, row) => {
        const isDeleted = Number(row.ESTADO) === 2;
        return (
          <div className="btn-group border-0" role="group" >
            {/* Ver / Editar */}

            <a href={`${cDocuments.urlDev}/csf/${row.CSF}`} target='blank' className="btn btn-outline-dark border-0" title="Ver CSF">
              <FiPrinter size={20} />
            </a>
            <button type="button" className="btn btn-outline-primary border-0" disabled={row.ESTADO == 2} onClick={() => { setSelectedItem(row); setShowModal(true); }} title="Ver Datos">
              <FiEdit size={20} className="ms-1" />
            </button>
            {isDeleted ? (
              <button type="button" className="btn btn-outline-success border-0" onClick={() => handledActive(row.ID)} title="Activar CSF" >
                <FiRefreshCcw size={20} />
              </button>
            ) : (
              <button type="button" className="btn btn-outline-danger border-0" onClick={() => handledDelete(row.ID)} title="Desactivar CSF">
                <FiTrash2 size={20} />
              </button>
            )}
          </div>
        );
      }
    }
  ];

  const handledDelete = (id) => {
    Swal.fire({
      title: 'Atención',
      text: "Está por desactivar una CSF, ¿Desea de continuar con esta acción?",
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deactivateBillings(id, idCustomer));
      }
    })
  }

  const handledActive = (id) => {
    Swal.fire({
      title: 'Atención',
      text: "Está por activar una CSF, ¿Desea de continuar con esta acción?",
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(activateBillings(id, idCustomer));
      }
    })
  }

  return (
    <>
      {showModal && (<M_NewBillings onClose={handleCloseModal} selectedItem={selectedItem} />)}
      <div className='row'>
        <div className='col-12 mb-3'>
          <img src={icosIndicators['checklist']} className="img-fluid" width={28} alt="sales" />
          <span className='ms-2 me-3 fw-bold h4'>Datos de facturacion</span>
        </div>
        <div className='col-3 mb-3'>
          <button type="button" className="btn btn-outline-primary" onClick={() => { setSelectedItem(null); handleOpenModal(); }}>Nuevo dato de facturacion</button>
        </div>

        <div className='col-12'>
          <Table
            columns={columns}
            data={data}
            function_={(row) => { setSelectedItem(row.ID) }}
            placeholderSearch="Buscar por: RFC, Razon social"
            showPagination={true}
            showControls={true}
            showTotals={false}
          />
        </div>
      </div>
    </>
  )
}
